// bluaIQ — the screen a signer lands on when the signing link will not load.
//
// THIS IS THE ALREADY-USED-LINK PATH, and it is the most common failure in the
// whole flow: signing NULLs `signToken`, so re-opening the emailed link (a
// double-click, a forwarded mail, "let me check what I signed") no longer
// matches on GET and returns 404. The page never reaches the form — it lands
// here. It is also where an invalid or expired load ends up.
//
// Presentational and prop-only ON PURPOSE (same reasoning as
// ContractSignErrorNotice): no router/query/auth hooks, so it mounts standalone
// in the Playwright component harness and the copy an actual signer reads can be
// proven in a real browser at 390px — not merely matched in source, which is all
// this path had before (Codex #479 P1, item 5).
//
// Spanish addresses the signer as USTED — formal and neutral. An outside
// contractor receiving a legal document from a company is not a "tú".

import { AlertTriangle } from 'lucide-react'

export function ContractSignInvalidLink({ isEs }: { isEs: boolean }) {
  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center p-5">
      <div
        data-testid="sign-invalid-link"
        role="alert"
        className="bg-white border border-[#ECEAE4] rounded-xl p-8 text-center max-w-md"
      >
        <AlertTriangle size={48} className="mx-auto text-[#F5A623] mb-4" aria-hidden="true" />
        <h2 data-testid="sign-invalid-link-title" className="text-[18px] font-[900] text-[#1C1A17] mb-2">
          {isEs ? 'Enlace no válido' : 'Invalid link'}
        </h2>
        <p data-testid="sign-invalid-link-body" className="text-[12px] font-[600] text-[#9E9890]">
          {/* Names ALREADY USED explicitly: the previous copy said only "invalid
              or expired", which reads as an error to someone whose real
              situation is "I already signed this". */}
          {isEs
            ? 'Este enlace de firma no es válido, ya se usó o venció. Solicite a su constructor que le envíe uno nuevo.'
            : 'This signing link is invalid, already used, or expired. Ask your builder to send you a new one.'}
        </p>
      </div>
    </div>
  )
}
